import { styled, Loader as BaseLoader } from '@innowise-group/mui-kit';
import { LabeledSwitch as BaseSwitch } from '@shared-mui-components';

export const Switch = styled(BaseSwitch)``;

export const Loader = styled(BaseLoader)`
  margin: 15px 10px 10px 10px;
`;
